<!-- ── Header: meta on left, actions on right ── -->
<div class="header">
  <div class="header-main">
    <!-- Category + ID -->
    <div class="category-row">
      <asset-type-tag [assetType]="asset().asset_type" />

      <span class="asset-id">ID: {{ asset().asset_id }}</span>
    </div>

    <!-- Title -->
    <div class="title-row">
      <h1 class="title">{{ asset().asset_name }}</h1>
    </div>

    <!-- Row 1: Access · Rating · Views · Downloads · Trust badges -->
    <div class="meta-row">
      <asset-access-type [accessLevel]="asset().access" />
      @if (asset().download_count) {
        <span class="meta-dot"></span>
        <span class="meta-item">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          {{ downloadCountText() }}
        </span>
      }
      <asset-trust-badge
        [isGovernanceVerified]="asset().governance_verified"
        [isRaiVerified]="asset().responsible_ai_verified"
        [isVerificationInProgress]="asset().verification_in_progress"
      />
    </div>
  </div>
  <!-- /header-main -->

  <!-- Action buttons (top right) -->
  <div class="header-actions">
    <button
      class="bookmark-btn"
      [class.bookmark-btn--active]="isBookmarked()"
      (click)="handleBookmarkButtonClick()"
      title="Bookmark"
      [disabled]="isBookmarkButtonLoading()"
    >
      @if (assetService.listAllBookmarks.isLoading()) {
        <loader size="22px" />
      } @else {
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          [attr.fill]="isBookmarked() ? '#007DB7' : 'none'"
          stroke="#007DB7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
      }
    </button>
    @if (asset().asset_type === 'Dataset') {
      <asset-download-button
        [assetId]="assetId()"
        [hasAccess]="asset().current_user_has_access"
        [hasDownload]="asset().download_status === 'READY'"
        [assetName]="asset().asset_name"
        [ownerName]="asset().owner_name"
        [ownerEmail]="asset().owner_email"
      />
    }
    @if (asset().asset_type === 'AI Product') {
      <asset-launch-button
        [assetName]="asset().asset_name"
        [hasAccess]="asset().current_user_has_access"
        [assetId]="asset().asset_id"
        [productLink]="asset().location_uri"
        [ownerName]="asset().owner_name"
        [ownerEmail]="asset().owner_email"
      />
    }
    <!-- More menu: Copy Link + Report Issue only -->
    <div class="more-wrap" (click)="$event.stopPropagation()">
      <button
        class="btn btn--icon"
        aria-label="More options"
        title="More options"
        (click)="toggleMoreMenu($event)"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </button>
      @if (moreOpen()) {
        <div class="more-dropdown">
          <button class="more-opt" type="button" (click)="copyLink()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
            Copy Link
          </button>
          <div class="more-divider"></div>
          <button class="more-opt more-opt--danger" type="button" (click)="reportIssue()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Report an Issue
          </button>
        </div>
      }
    </div>
  </div>
  <!-- /header-actions -->
</div>
<!-- /header -->
